import { render, staticRenderFns } from "./textChecklist.vue?vue&type=template&id=10d9050c&scoped=true"
import script from "./textChecklist.vue?vue&type=script&lang=js"
export * from "./textChecklist.vue?vue&type=script&lang=js"
import style0 from "./textChecklist.vue?vue&type=style&index=0&id=10d9050c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9050c",
  null
  
)

export default component.exports